/**
 * The Hive brand mark: three honeycomb cells.
 *
 * Geometry is a real honeycomb tiling rather than three hexagons placed by eye.
 * Each cell is a regular pointy-top hexagon of circumradius 6 in a 24x24 box, so
 * its width is 6*sqrt(3) and its height is 12. Rows step down by 1.5 * 6 = 9 and
 * are offset horizontally by half a width, which is what makes the three cells
 * share edges exactly instead of merely touching.
 *
 * Drawn in `currentColor` and sized by the caller, so it inherits colour from
 * whatever it sits in and stays crisp at any size -- unlike the emoji it
 * replaced, which rendered as a different picture on every platform.
 */
export function HiveMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinejoin="round"
      // Decorative: the "Hive" wordmark next to it carries the meaning, so a
      // screen reader announcing this too would just be repetition.
      aria-hidden="true"
      focusable="false"
    >
      <polygon points="12,1.5 17.2,4.5 17.2,10.5 12,13.5 6.8,10.5 6.8,4.5" />
      <polygon points="6.8,10.5 12,13.5 12,19.5 6.8,22.5 1.6,19.5 1.6,13.5" />
      <polygon points="17.2,10.5 22.4,13.5 22.4,19.5 17.2,22.5 12,19.5 12,13.5" />
    </svg>
  );
}
